import type { FC } from "react";

import { BasicModal } from "@similarweb/ui-components";

import { AfterTrialHookContainer } from "app/components/React/AfterTrialHook/AfterTrialHookContainer";

interface AfterTrialModalProps {
    isAfterTrialModalOpen: boolean;
    onCloseHookModal: () => void;
}

const AfterTrialModal: FC<AfterTrialModalProps> = ({ isAfterTrialModalOpen, onCloseHookModal }) => (
    <BasicModal
        isOpen={isAfterTrialModalOpen}
        closeIconConfig={{
            show: true,
            onClick: onCloseHookModal,
        }}
        dataAutomation="after-trial-modal"
        customStyles={{ content: { width: 934, padding: 16 } }}
    >
        <AfterTrialHookContainer />
    </BasicModal>
);

export default AfterTrialModal;
